import React from 'react';
import { Route, Switch } from 'react-router-dom';

import ErrorPage from 'app/components/ErrorPage';
import MainLayout from 'app/components/layouts/MainLayout';
import { HTTP_STATUS_CODE } from 'app/constants/ErrorConstants';
import VideoPageRoute from './VideoPageRoute';

const basePath = '/v2/video';

export default (
  <Route path={basePath}>
    <MainLayout>
      <Switch>
        <Route path={`${basePath}/:videoId`}>
          <VideoPageRoute />
        </Route>
        <Route>
          <ErrorPage httpStatusCode={HTTP_STATUS_CODE.NOT_FOUND} />
        </Route>
      </Switch>
    </MainLayout>
  </Route>
);
